import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import IconAddress from './IconAddress';
import IconPhone from './IconPhone';
import IconWebsite from './IconWebsite';
import IconDistance from './IconDistance';
import { getGeoStores } from './apis';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const TheComp: FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('dp3.teaser');
    const [listA, setListA] = useState([
        {
            name: t('ExperienceEF.item1_title'),
            address: t('ExperienceEF.item1_address'),
            city: t('ExperienceEF.item1_phone'),
            state: t('ExperienceEF.item1_website'),
            campaignTime: t('ExperienceEF.item1_dcountry'),
            campaignTime2: t('ExperienceEF.item1_distance'),
        },
        {
            name: t('ExperienceEF.item2_title'),
            address: t('ExperienceEF.item2_address'),
            city: t('ExperienceEF.item2_phone'),
            state: t('ExperienceEF.item2_website'),
            campaignTime: t('ExperienceEF.item2_dcountry'),
            campaignTime2: t('ExperienceEF.item2_distance'),
        },
        {
            name: t('ExperienceEF.item3_title'),
            address: t('ExperienceEF.item3_address'),
            city: t('ExperienceEF.item3_phone'),
            state: t('ExperienceEF.item3_website'),
            campaignTime: t('ExperienceEF.item3_dcountry'),
            campaignTime2: t('ExperienceEF.item3_distance'),
        },
    ]);
    const [zipCode, setZipCode] = useState('');
    const [errorTips, setErrorTips] = useState(''); // 错误提示
    const [theLatitude, setThelatitude] = useState<number | null>(null); // 纬度
    const [theLongitude, setThelongitude] = useState<number | null>(null); // 经度

    // 输入框改变
    const zipCodeChange = (e: any) => {
        setZipCode(e.target.value);
        setErrorTips('');
    };
    // 获取经伟度
    const handleGetCurrentLocation = async () => {
        if (!window.navigator.geolocation) {
        } else {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    setThelatitude(latitude);
                    setThelongitude(longitude);
                    initList1({ latitude, longitude });
                },
                (error) => {
                    console.error('Error getting location:', error);
                },
            );
        }
    };
    // 获取门店列表1--根据经纬度
    const initList1 = async (params: any) => initList(params);

    // 获取门店列表2--根据zipCode
    const initList2 = async () => {
        if (!zipCode) {
            setErrorTips(t('ExperienceEF.error_tips'));
            return;
        }
        initList({
            zipCode: zipCode,
            latitude: theLatitude,
            longitude: theLongitude,
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_store',
            page_name: `${locale}/delta-pro-3-portable-power-station`,
            button_name: t('ExperienceEF.notice_btn'),
        });
    };
    // 获取门店列表--根据zipCode或者地理定位
    const initList = async (params: any) => {
        const res = await getGeoStores(params, locale);
        if (res.code === '0') {
            const { data = [] } = res;
            const data2 = (data || []).filter((item: any) => {
                return item.distanceKm <= 100;
            });

            if (data2.length > 0) {
                setListA(data2 || []);
                setErrorTips('');
            } else if (data2.length === 0 && data.length > 0) {
                setListA([]);
                setErrorTips(t('ExperienceEF.distanceTips'));
            } else {
                setErrorTips('');
            }
        } else {
            setErrorTips(res.message);
        }
    };
    // 是否进入视图
    const enterViewChange = () => {
        const elem = document.querySelector('#dp3-teaser-L');
        if (elem) {
            const ob1 = new IntersectionObserver(
                (elems) => {
                    const elem = elems[0];
                    if (elem.isIntersecting) {
                        handleGetCurrentLocation();
                    } else {
                    }
                },
                {
                    rootMargin: '100px', //偏移量,-100px表示从底部伸出100px了
                    threshold: 0, //0 - 1;0表示监听元素有部分进入了可视区
                },
            );
            ob1.observe(elem);
        }
    };
    useEffect(() => {
        enterViewChange();
    }, []);

    return (
        <div id="dp3-teaser-L" className={`${css.thecomp} dp3-teaser-L`}>
            <div className="dp3-module-box">
                <h2 className="dp3-title left ExperienceEF-title">{t('ExperienceEF.title')}</h2>
                <div className="ExperienceEF-input-box">
                    <input type="text" className="ExperienceEF-input" placeholder={t('ExperienceEF.input_tips')} value={zipCode} onChange={zipCodeChange} />
                    <button className="ExperienceEF-input-btn" onClick={initList2}>
                        {t('ExperienceEF.notice_btn')}
                    </button>
                </div>
                <div className="ExperienceEF-errorTips">{errorTips}</div>
            </div>
            <div className="ExperienceEF-list">
                {listA.map((item: any, index: number) => {
                    return (
                        <div className="ExperienceEF-item" key={index}>
                            {item?.name && <div className="ExperienceEF-item-title">{item.name}</div>}
                            {item?.address && (
                                <div className="ExperienceEF-item-sub">
                                    <IconAddress />
                                    {item.address}
                                </div>
                            )}
                            {item?.city && (
                                <div className="ExperienceEF-item-sub">
                                    <IconPhone />
                                    {item.city}
                                </div>
                            )}
                            {item?.state && (
                                <div className="ExperienceEF-item-sub">
                                    <IconWebsite />
                                    {item.state}
                                </div>
                            )}
                            {item?.campaignTime && (
                                <div className="ExperienceEF-item-sub">
                                    <IconDistance />
                                    {item.campaignTime}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TheComp;
